import './mini-shop-label.styles.css';

const MiniShopLabel = ({ cat, onClick, isSelected }) => {
  const { text } = cat;

  return (
    <button 
      className={`mini-shop-label ${isSelected ? 'mini-shop-label-selected' : ''}`} 
      onClick={onClick}
    >
      <span className="top-left-border"></span>
      <span className="top-border"></span>
      <p className="mini-shop-label-text">{text}</p>
      <span className="bottom-border"></span>
      <span className="bottom-right-border"></span>
    </button>
  );
};

export default MiniShopLabel;
